import { memo } from "react";

import Line from "../../../../../public/assets/icon/sns/line.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const LineIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Line });
	return <Icon />;
};

export default memo(LineIcon);
